// extracted by mini-css-extract-plugin
export var statItem = "_ko-1";
export var statsRow = "_ko-0";